const SpaceWrapper = ({ children, className }) => (
  <div
    className={`py-12 px-6 md:py-32 md:px-48 bg-black overflow-x-hidden md:overflow-auto ${className}`}
  >
    {children}
  </div>
);
export default SpaceWrapper;
